import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Download, Smartphone } from 'lucide-react';
import { Button } from './Button';
import { goToCheckout } from '../utils/checkout';
export function OfferBlock() {
  return <section id="offer-section" className="py-24 bg-white" data-id="element-80">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy rounded-3xl p-8 md:p-12 text-center text-white shadow-2xl relative overflow-hidden" data-id="element-82">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-mint/10 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-83"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-mint/10 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-84"></div>

          <div className="relative z-10" data-id="element-85">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-86">
              Consigue tu copia de{' '}
              <span className="text-mint" data-id="element-87">Cero Niebla Mental</span> hoy mismo.
            </h2>
            <p className="text-xl text-white/80 mb-10 font-light" data-id="element-88">
              Empieza a pensar con claridad antes de tu próxima entrega
              importante.
            </p>

            <div onClick={goToCheckout} role="button" tabIndex={0} onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              goToCheckout();
            }
          }} className="bg-white/10 backdrop-blur-md rounded-2xl p-8 mb-10 border border-white/20 inline-block w-full max-w-md mx-auto relative cursor-pointer hover:bg-white/15 hover:border-mint/40 hover:scale-[1.02] transition-all duration-300" data-id="element-89">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-mint text-navy text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full shadow-md whitespace-nowrap" data-id="element-90">
                🔥 Oferta Especial · 60% OFF
              </div>
              <div className="text-sm text-mint font-bold uppercase tracking-wider mb-3 mt-2" data-id="element-91">
                Precio de Lanzamiento
              </div>
              <div className="flex items-baseline justify-center gap-3 mb-2 flex-wrap" data-id="element-92">
                <span className="text-xl md:text-2xl font-normal text-white/50 line-through decoration-2" data-id="element-93">
                  $14.900
                </span>
                <span className="text-xs font-bold bg-red-500/90 text-white px-2 py-1 rounded" data-id="element-94">
                  -60%
                </span>
              </div>
              <div className="text-5xl md:text-6xl font-bold mb-2" data-id="element-95">
                $5.990{' '}
                <span className="text-2xl font-normal text-white/70" data-id="element-96">CLP</span>
              </div>
              <div className="text-white/70 text-sm" data-id="element-97">
                Pago único · Sin suscripciones
              </div>
              <div className="mt-4 pt-4 border-t border-white/10 text-mint text-sm font-medium" data-id="element-98">
                Ahorras $9.000 CLP hoy
              </div>
            </div>

            <Button className="w-full sm:w-auto text-lg px-10 py-5 mb-8 bg-mint text-navy hover:bg-mint-light shadow-[0_0_20px_rgba(191,219,214,0.3)]" data-id="element-99">
              QUIERO RECUPERAR MI ENFOQUE AHORA
            </Button>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-white/70" data-id="element-100">
              <div className="flex items-center" data-id="element-101">
                <Lock className="w-4 h-4 mr-2 text-mint" data-id="element-102" />
                Pago 100% seguro
              </div>
              <div className="flex items-center" data-id="element-103">
                <Download className="w-4 h-4 mr-2 text-mint" data-id="element-104" />
                Acceso instantáneo
              </div>
              <div className="flex items-center" data-id="element-105">
                <Smartphone className="w-4 h-4 mr-2 text-mint" data-id="element-106" />
                PDF para todos los dispositivos
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}